import React, { useEffect, useRef, useState } from 'react';
import { Banknote, TriangleAlert, ShieldCheck, ReceiptText, Camera, Car, Check } from 'lucide-react';

const RESOLVE_STEPS = [
  { icon: Camera, label: 'Photo evidence', status: 'Collected' },
  { icon: Car, label: 'Telematics tracking', status: 'Connected' },
  { icon: Banknote, label: 'Issue refunds', status: 'Refund sent' },
  { icon: TriangleAlert, label: 'Rental violations', status: 'Billed' },
  { icon: ShieldCheck, label: 'Insurance claims', status: 'Claim filed' },
  { icon: ReceiptText, label: 'Tolls & Tickets collections', status: 'Billed' },
];

/** RentSuccess visual — resolution steps reveal one by one on scroll. */
const ResolveVisual = () => {
  const containerRef = useRef(null);
  const [revealed, setRevealed] = useState(0);

  useEffect(() => {
    const node = containerRef.current;
    if (!node) return undefined;
    if (typeof IntersectionObserver === 'undefined') {
      setRevealed(RESOLVE_STEPS.length);
      return undefined;
    }
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setRevealed(1);
          observer.disconnect();
        }
      },
      { threshold: 0.25 }
    );
    observer.observe(node);
    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    if (revealed === 0 || revealed >= RESOLVE_STEPS.length) return undefined;
    const timer = window.setTimeout(() => setRevealed((n) => n + 1), 420);
    return () => window.clearTimeout(timer);
  }, [revealed]);

  return (
    <div ref={containerRef} className="mpa-resolve">
      {RESOLVE_STEPS.map((step, i) => {
        const isVisible = i < revealed;
        const Icon = step.icon;
        return (
          <div key={step.label} className={`mpa-resolve-row${isVisible ? ' mpa-liquid-in' : ' mpa-hidden'}`}>
            <span className="mpa-resolve-icon">
              <Icon size={20} aria-hidden="true" />
            </span>
            <p className="mpa-resolve-label">{step.label}</p>
            <span
              className={`mpa-resolve-status${isVisible ? ' mpa-liquid-morph' : ' mpa-hidden'}`}
              style={isVisible ? { animationDelay: '260ms' } : undefined}
            >
              <Check size={14} strokeWidth={3} aria-hidden="true" />
              {step.status}
            </span>
          </div>
        );
      })}
    </div>
  );
};

export default ResolveVisual;
